import { CommonModule } from "@angular/common";
import { FieldLabelComponent } from "./field/field-label/field-label.component";
import { FieldTagComponent } from "./field/field-tag/field-tag.component";
import { FieldComponent } from "./field/field/field.component";
import { NgModule } from "@angular/core";
import { EditorModule } from "./field/field-editor/editor.module";
import { DisplayModule } from "./field/field-display/display.module";
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ReassignPurchaseComponent } from './reassign-purchase/reassign-purchase.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from "@ngx-translate/core";
import { DatePickerModule } from 'primeng/datepicker';
import { InputCronComponent } from './input-cron/input-cron.component';


@NgModule({
    declarations: [
      FieldComponent,
      FieldTagComponent,
      FieldLabelComponent,
      ReassignPurchaseComponent,
      // Ici et non dans ComponentsModule : la modale de règle de tag (TableDataModule) s'en sert aussi.
      InputCronComponent
    ],
    exports: [
      FieldComponent,
      FieldTagComponent,
      FieldLabelComponent,
      ReassignPurchaseComponent,
      InputCronComponent
    ],
    imports: [
      CommonModule,
      EditorModule,
      DisplayModule,
      TooltipModule,
      DropdownModule,
      TagModule,
      FormsModule,
      ButtonModule,
      ReactiveFormsModule,
      InputSwitchModule,
      InputTextModule,
      TranslateModule,
      DatePickerModule
    ]
  })
  export class SharedComponentsModule { }